import { Variable } from '@ff-scene-plugins/gift-shared/Variable';
import { paintablesToFfCanvas } from '@gift-variable-plugins/paintables-shared/paintablesToFfCanvas';
import { PaintablesVariableInput } from '@gift-variable-plugins/paintables-shared/PaintablesVariableInput';
import { PaintablesVariableOptions } from '@gift-variable-plugins/paintables-shared/PaintablesVariableOptions';

export const paintablesPdpPlugin: Variable.Plugin<PaintablesVariableOptions, PaintablesVariableInput> = {
    pluginId: 'paintables',
    toFfCanvas: paintablesToFfCanvas
};